import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IMAGE_SIZES, getProductImageUrl } from 'utils/productImages';

const getImageSrcSet = (baseSku, image) =>
  // eslint-disable-next-line max-len
  `${getProductImageUrl(baseSku, image, IMAGE_SIZES.S_150)} 1x, ${getProductImageUrl(baseSku, image, IMAGE_SIZES.S_280)} 2x`;

export default class ImageWithCorner extends PureComponent {
  static propTypes = {
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.shape({
        hash: PropTypes.string.isRequired,
        sku: PropTypes.string,
      }),

    }).isRequired,
    extraClass: PropTypes.string,
  };

  render() {
    const { product: { sku, name, image }, extraClass } = this.props;
    const fopImageClass = ['fop-img'];
    if (extraClass) {
      fopImageClass.push(extraClass);
    }
    return (
      <div>
        <img
          alt={name}
          className={classNames(fopImageClass)}
          src={getProductImageUrl(sku, image, IMAGE_SIZES.S_150)}
          srcSet={image ? getImageSrcSet(sku, image) : null}
          aria-hidden="true"
        />
      </div>
    );
  }
}
